<div fxLayout="row" fxLayoutAlign="space-between center">
  <ng-container *ngIf="displayContent"><ng-content></ng-content></ng-container>
  <vpfa-loading-value *ngIf="isLoading"></vpfa-loading-value>
</div>
